import { api, ApiError } from "@/api/api";
import { CreatePrompt, Prompt } from "@/api/prompts-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useCreatePrompt() {
  const queryClient = useQueryClient();
  return useMutation<Prompt, ApiError, CreatePrompt>({
    mutationKey: ["POST", "prompts"],
    mutationFn: api.prompts.post,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GET", "prompts"] });
    },
  });
}
